import { css } from '@flipster/styled-system/css';
import { flex } from '@flipster/styled-system/patterns';

export const colStyles = {
  symbol: css.raw({ flex: 1, minW: 0 }),
  turnover24h: flex.raw({ flexBasis: 100, flexShrink: 0, justify: 'flex-end' }),
  priceChange: flex.raw({
    flexBasis: 104,
    flexShrink: 0,
    flexDirection: 'column',
    alignItems: 'flex-end',
    justify: 'center',
  }),
} as const;
